import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import PositionOptions from 'src/components/PositionOptions';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { positionOption } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { Sliders } from './sliderGenerator';
const PositionOption = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Section size='small' bottomBorder>
      <ItemWrapper
        size='small'
        title={getI18n('salesChannelContent.index.positionOption')}>
        <Field name={positionOption}>
          {(props, meta) => {
            return (
              <PositionOptions
                data={props.value || []}
                onChange={props.onChange}
              />
            );
          }}
        </Field>
      </ItemWrapper>
      <Sliders />
    </Section>
  );
};
export default PositionOption;
